import RedCloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import {
  DeleteConfirmationModalType,
  DeleteConfirmationProps,
} from '@/common/components/imageGallery/components/Extensions/deleteConfigration/modal/deleteConfirmationModal.type';
import { Flex } from 'styled-system/jsx';

export default ({
  closeModal,
  open,
  onDeletePhoto,
  loading,
}: DeleteConfirmationModalType) => {
  return (
    <MainModal closeModal={loading ? () => {} : closeModal} open={open}>
      <DeleteConfirmationModal
        closeModal={loading ? () => {} : closeModal}
        onDeletePhoto={onDeletePhoto}
        loading={loading}
      />
    </MainModal>
  );
};
const DeleteConfirmationModal = ({
  closeModal,
  onDeletePhoto,
  loading,
}: DeleteConfirmationProps) => {
  return (
    <Flex flexDirection="column" gap="1rem" alignItems="center">
      <RedCloseIcon />
      <Typography color="black-1">آیا از حذف تصویر مطمئن هستید؟</Typography>
      <Flex w="100%" gap="1rem">
        <Button
          disabled={loading}
          flex={1}
          variant="outlined"
          color="common"
          onClick={closeModal}
        >
          خیر
        </Button>
        <LoadingButton
          loading={loading!}
          loadingColor={'primary'}
          onClick={onDeletePhoto}
          flex={1}
          variant="contained"
          color="danger"
        >
          بله
        </LoadingButton>
      </Flex>
    </Flex>
  );
};
